import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import Group from "../../../ServicosAcolhimento/Visualizar/Group";
import { TableEducacao } from "../../../../components/TableEducacao";
import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import CriancaService from "../../../../../main/services/CriancaService";
import { Tooltip } from "@chakra-ui/react";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import { hasFormChanged } from "../../../../utils/hasFormChanged";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import { IconeDownload } from "../../../../components/IconeDownload";
import { createCustomFile } from "../../../../utils/createCustomFile";
import { useHistory } from "react-router";

export const VisualizarPageEducacao = ({
  id,
  setIsTrueVisualizar,
  initialValues,
  setInitialValues,
  setUnidades,
  url,
  idAnexo,
  scrollToField,
  idAba,
  idTipoPendencia,
}) => {
  const { values, setFieldValue } = useFormikContext();
  const { setEditarEducCrianca } = useAppContext();
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    setLoading(true);
    CriancaService.getCriancaEducacao(id)
      .then((res) => {
        if (res.data) {
          if (res.data.unidadesEscolares) {
            setUnidades(true);
          } else {
            setUnidades(false);
          }

          const escolasFormated = res.data.unidadesEscolares.map(
            (unidadeEscolar) => {
              if (unidadeEscolar.matriculaAnexo) {
                const fakeFile = createCustomFile(
                  [unidadeEscolar.matriculaAnexo.arquivoBase64],
                  unidadeEscolar.matriculaAnexo.arquivoNome,
                  {
                    type: unidadeEscolar.matriculaAnexo.arquivoTipo,
                    idAnexo: unidadeEscolar.matriculaAnexo.idAnexo
                      ? unidadeEscolar.matriculaAnexo.idAnexo
                      : 0,
                  }
                );

                return {
                  ...unidadeEscolar,
                  nome: unidadeEscolar.nome ? unidadeEscolar.nome : "",
                  escolaAtual:
                    res.data.frequentaEscola === "S" &&
                    unidadeEscolar.escolaAtual === "S"
                      ? true
                      : false,
                  matriculaAnexo: fakeFile,
                };
              } else {
                return {
                  ...unidadeEscolar,
                  nome: unidadeEscolar.nome ? unidadeEscolar.nome : "",
                  escolaAtual:
                    res.data.frequentaEscola === "S" &&
                    unidadeEscolar.escolaAtual === "S"
                      ? true
                      : false,
                };
              }
            }
          );

          const sortedEscolasFormated = escolasFormated.sort((a, b) => {
            if (a.escolaAtual && !b.escolaAtual) {
              return -1;
            } else if (!a.escolaAtual && b.escolaAtual) {
              return 1;
            }
            return 0;
          });

          setData({
            ...res.data,
            unidadesEscolares:
              res.data.unidadesEscolares &&
              res.data.unidadesEscolares.length > 0
                ? sortedEscolasFormated
                : [],
          });
          setFieldValue("escolaridadeRepetida", res.data.escolaridadeRepetida);
          setInitialValues({
            frequentaEscola: res.data.frequentaEscola,
            escolaridadeRepetida:
              res.data.escolaridadeRepetida === "S" ? "S" : "N",
            educacaoEspecial:
              res.data.frequentaEscola === "S" ? res.data.educacaoEspecial : "",
            idEscolaridade:
              res.data.frequentaEscola === "S" ? res.data.escolaridade : "",
            idTipoJustificativaEscolaridade: res.data
              .tipoJustificativaEscolaridade
              ? res.data.tipoJustificativaEscolaridade
              : "",
            descricaoJustificativa: res.data.justificativaEscolaridade
              ? res.data.justificativaEscolaridade
              : "",
            unidadesEscolares: sortedEscolasFormated,
          });
          setFieldValue("unidadesEscolares", sortedEscolasFormated);
          if (url.includes("editar")) {
            setIsTrueVisualizar(false);
          } else {
            setIsTrueVisualizar(true);
          }
        } else {
          let path = `/crianca/visualizar-educacao/${id}`;
          path += idAnexo
            ? `?idAnexo=${idAnexo}`
            : idAba && idTipoPendencia
            ? `?idAba=${idAba}&idTipoPendencia=${idTipoPendencia}`
            : "";

          history.push(path);

          setIsTrueVisualizar(false);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);

        let path = `/crianca/visualizar-educacao/${id}`;
        path += idAnexo ? `?idAnexo=${idAnexo}` : "";
        history.push(path);

        setIsTrueVisualizar(false);
        setLoading(false);
      });
  }, [
    id,
    setFieldValue,
    setInitialValues,
    setIsTrueVisualizar,
    url,
    history,
    idAnexo,
    setUnidades,
    idAba,
    idTipoPendencia,
  ]);

  const getAnexoEducacao = (id, opcao) => {
    CriancaService.getAnexo(id, opcao)
      .then((res) => {
        if (opcao === "download") {
          const downloadUrl = res.config.url;
          window.open(downloadUrl, "_blank");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const columns = [
    {
      Header: "Nome",
      accessor: "nome",
      Cell: (props) => {
        const { value } = props;
        const truncatedValue =
          value && value.length > 120 ? value.slice(0, 120) + "..." : value;

        return (
          <Tooltip
            label={`${
              props.value && props.value.length > 120 ? `${props.value}` : ""
            }`}
          >
            {truncatedValue ? truncatedValue : ""}
          </Tooltip>
        );
      },
    },
    {
      Header: "Escola Atual",
      accessor: "escolaAtual",
      Cell: (props) => {
        return (
          <span>
            {props?.value && data.frequentaEscola === "S" ? "Sim" : ""}
          </span>
        );
      },
    },
    {
      Header: "Comprovante de Matrícula Escolar",
      accessor: "matriculaAnexo",
      Cell: (props) => {
        return (
          <Flex justifyContent={"center"}>
            {props?.value ? (
              <button
                type="button"
                onClick={() =>
                  getAnexoEducacao(props?.value?.idAnexo, "download")
                }
              >
                <IconeDownload />
              </button>
            ) : (
              ""
            )}
          </Flex>
        );
      },
    },
  ];
  return !loading ? (
    <Group
      title="Educação"
      border={idAnexo === "22" ? "3px solid #4299E199" : ""}
      scrollToField={idAnexo === "22" ? scrollToField : null}
    >
      <Flex mt="17px" direction={"column"} gap="18px">
        {setEditarEducCrianca(hasFormChanged(initialValues, values))}
        <Box>
          <Text as="b">Frequenta Escola?</Text>
          <Text>{data.frequentaEscola === "S" ? "Sim" : "Não"}</Text>
        </Box>

        {data.tipoJustificativaEscolaridade && (
          <Box>
            <Text as="b">Justificativa</Text>
            {data.tipoJustificativaEscolaridade.id === 6 ? (
              <Text>
                {data.tipoJustificativaEscolaridade.descricao}{" "}
                {data.justificativaEscolaridade}
              </Text>
            ) : (
              <Text>{data.tipoJustificativaEscolaridade.descricao}</Text>
            )}
          </Box>
        )}
        {data.frequentaEscola === "S" ? (
          <Box>
            <Text as="b">Educação Especial?</Text>
            <Text>{data.educacaoEspecial === "S" ? "Sim" : "Não"}</Text>
          </Box>
        ) : (
          ""
        )}
        {data.escolaridade && (
          <Box>
            <>
              <Text as="b">Escolaridade</Text>
              <Text>{data.escolaridade.descricao}</Text>
            </>
          </Box>
        )}
        {data.frequentaEscola === "S" && (
          <Box>
            <Text as="b">Escolaridade Repetida</Text>
            <Text>{data.escolaridadeRepetida === "S" ? "Sim" : "Não"}</Text>
          </Box>
        )}
      </Flex>
      {data.unidadesEscolares && data.unidadesEscolares.length > 0 && (
        <TableEducacao
          columns={columns}
          data={data.unidadesEscolares}
          frequentaEscola={data.frequentaEscola}
        />
      )}
    </Group>
  ) : (
    <Box mt={4}>
      <LoadingSpinner />
    </Box>
  );
};
